import { createSlice } from "@reduxjs/toolkit";

const tableSlice = createSlice({
    name: "table",
    initialState: { selectedItems: [{ page: null, value: null }] },
    reducers: {
        toggleSelect: (state: any, action: any) => {
            const newItem = action.payload;

            const itemIndex = state.selectedItems.findIndex(
                (item: any) =>
                    item.page === newItem.page && item.value === newItem.value
            );

            if (itemIndex !== -1) {
                state.selectedItems.splice(itemIndex, 1);
            } else {
                state.selectedItems.push(newItem);
            }
        },

        toggleSelectAll: (state: any, action: any) => {
            state.selectedItems = action.payload;
        },
    },
});

export const { toggleSelect, toggleSelectAll } = tableSlice.actions;

export default tableSlice.reducer;
